// @flow weak

import {combineReducers} from 'redux';
import {
  GET_REQUEST, GET_SUCCESS,
  GET_FAILURE, UPDATE_REQUEST,
  UPDATE_SUCCESS, UPDATE_FAILURE,
  PRODUCTS_REQUEST, PRODUCTS_SUCCESS,
  PRODUCTS_FAILURE, VARIANTS_REQUEST,
  VARIANTS_SUCCESS, VARIANTS_FAILURE,
  ADDITIONAL_ROW_CREATE_REQUEST, ADDITIONAL_ROW_CREATE_SUCCESS,
  ADDITIONAL_ROW_CREATE_FAILURE, ADDITIONAL_ROW_UPDATE_REQUEST,
  ADDITIONAL_ROW_UPDATE_SUCCESS, ADDITIONAL_ROW_UPDATE_FAILURE,
  ADDITIONAL_ROW_REMOVE_REQUEST, ADDITIONAL_ROW_REMOVE_SUCCESS,
  ADDITIONAL_ROW_REMOVE_FAILURE, SET_ACTIVE_ADDITIONAL_ROW,
  LINKED_ADDITIONAL_ROW_UPDATE_REQUEST, LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS,
  LINKED_ADDITIONAL_ROW_UPDATE_FAILURE, LINKED_ADDITIONAL_ROW_REMOVE_REQUEST,
  LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS, LINKED_ADDITIONAL_ROW_REMOVE_FAILURE,
  SET_ACTIVE_LINKED_ADDITIONAL_ROW,
  CLEAR, SET_NOTE_ROW,
  ORDER_ROW_UPDATE_REQUEST, ORDER_ROW_UPDATE_FAILURE,
  ORDER_ROW_UPDATE_SUCCESS, TOGGLE_REPORT_DIALOG,
  UPDATE_REPORT_FILTER, EXTRA_ROW_UPDATE_REQUEST,
  EXTRA_ROW_UPDATE_FAILURE, EXTRA_ROW_UPDATE_SUCCESS,
} from '../actions/purchaseOrderView';
import _ from 'lodash/fp';
import {
  sortByIndex,
} from './configTemplateView';
import {productRowsByRoom, rowsToProductRows} from './helpers';

const active = (state = null, action) => {
  switch (action.type) {
    case GET_SUCCESS:
    case UPDATE_SUCCESS:
      return {
        ...action.order,
      };
    case GET_REQUEST:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

export const additionalRowsByRoom = (rows, rooms, additionalRows, linkedRows) => {
  const productRows = _.flow(rowsToProductRows(rooms), _.sortBy(['room.sortIndex']))(additionalRows);
  const linkedProductRows = _.flow(rowsToProductRows(rooms), _.sortBy(['room.sortIndex']))(linkedRows);

  return _.flow(
    _.reduce((list, room) => {
      const roomProductRows = _.filter(r => r.room.id === room.id, productRows);
      const roomLinkedProductRows = _.filter(r => r.room.id === room.id, linkedProductRows);
      if (roomProductRows.length || roomLinkedProductRows.length) {
        return [...list, {...room, productRows: roomProductRows, linkedProductRows: roomLinkedProductRows}];
      }
      return list;
    }, []),
    sortByIndex,
  )(rooms);
};


const defaultRowsState = {
  rooms: [],
  rows: [],
  rowsById: {},
  extraRows: [],
  extraRowsById: {},
  allRowsByRoom: [],
};

const rows = (state = defaultRowsState, action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return {
        ...state,
        rooms: action.rooms,
        rows: action.order.rows,
        rowsById: _.keyBy('id', action.order.rows),
        extraRows: action.order.extraRows,
        extraRowsById: _.keyBy('id', action.order.extraRows),
        allRowsByRoom: productRowsByRoom(action.rooms, action.order.rows, action.order.extraRows),
      };
    case ORDER_ROW_UPDATE_SUCCESS:
      return {
        ...state,
        rowsById: _.keyBy('id', action.rows),
        allRowsByRoom: productRowsByRoom(state.rooms, action.rows, state.extraRows),
      };
    case EXTRA_ROW_UPDATE_SUCCESS: {
      const extraRows = _.filter(r => r.id !== action.row.id, state.extraRows)
        .concat([action.row]);
      return {
        ...state,
        extraRows,
        extraRowsById: _.keyBy('id', extraRows),
        allRowsByRoom: productRowsByRoom(state.rooms, state.rows, extraRows),
      };
    }
    case GET_REQUEST:
    case CLEAR:
      return defaultRowsState;
    default:
      return state;
  }
};


const defaultAdditionalRows = {
  rows: [],
  rooms: [],
  additionalRows: [],
  linkedRows: [],
  allRowsByRoom: [],
};

const additionalRows = (state = defaultAdditionalRows, action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return {
        ...state,
        rows: action.order.rows,
        rooms: action.rooms,
        additionalRows: action.order.additionalRows,
        linkedRows: action.order.linkedAdditionalRows,
        allRowsByRoom: additionalRowsByRoom(action.order.rows, action.rooms, action.order.additionalRows, action.order.linkedAdditionalRows),
      };
    case ADDITIONAL_ROW_CREATE_SUCCESS: {
      const additionalRows = [...state.additionalRows, action.row];
      return {
        ...state,
        additionalRows,
        allRowsByRoom: additionalRowsByRoom(state.rows, state.rooms, additionalRows, state.linkedRows),
      };
    }
    case ADDITIONAL_ROW_UPDATE_SUCCESS: {
      const additionalRows = _.filter(r => r.id !== action.row.id, state.additionalRows)
        .concat([action.row]);
      return {
        ...state,
        additionalRows,
        allRowsByRoom: additionalRowsByRoom(state.rows, state.rooms, additionalRows, state.linkedRows),
      };
    }
    case ADDITIONAL_ROW_REMOVE_SUCCESS:
      const additionalRows = _.filter(r => r.id !== action.id, state.additionalRows);
      return {
        ...state,
        additionalRows,
        allRowsByRoom: additionalRowsByRoom(state.rows, state.rooms, additionalRows, state.linkedRows),
      };
    case LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS: {
      const linkedRows = _.filter(r => r.id !== action.row.id, state.linkedRows)
        .concat([action.row]);
      return {
        ...state,
        linkedRows,
        allRowsByRoom: additionalRowsByRoom(state.rows, state.rooms, state.additionalRows, linkedRows),
      };
    }
    case LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:
      const linkedRows = _.filter(r => r.id !== action.id, state.linkedRows);
      return {
        ...state,
        linkedRows,
        allRowsByRoom: additionalRowsByRoom(state.rows, state.rooms, state.additionalRows, linkedRows),
      };
    case CLEAR:
      return defaultAdditionalRows;
    default:
      return state;
  }
};

const customRows = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return action.order.customRows;
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const rooms = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return [
        ...action.rooms,
      ];
    case GET_REQUEST:
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case GET_REQUEST:
    case UPDATE_REQUEST:
    case GET_SUCCESS:
    case UPDATE_SUCCESS:
    case ADDITIONAL_ROW_REMOVE_REQUEST:
    case ADDITIONAL_ROW_REMOVE_SUCCESS:
    case LINKED_ADDITIONAL_ROW_REMOVE_REQUEST:
    case LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:
    case CLEAR:
      return null;
    case GET_FAILURE:
    case UPDATE_FAILURE:
    case ADDITIONAL_ROW_REMOVE_FAILURE:
    case LINKED_ADDITIONAL_ROW_REMOVE_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case GET_REQUEST:
    case UPDATE_REQUEST:
    case ADDITIONAL_ROW_REMOVE_REQUEST:
    case LINKED_ADDITIONAL_ROW_REMOVE_REQUEST:
      return true;
    case GET_SUCCESS:
    case UPDATE_SUCCESS:
    case GET_FAILURE:
    case UPDATE_FAILURE:
    case ADDITIONAL_ROW_REMOVE_SUCCESS:
    case ADDITIONAL_ROW_REMOVE_FAILURE:
    case LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:
    case LINKED_ADDITIONAL_ROW_REMOVE_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const productsIsFetching = (state = false, action) => {
  switch (action.type) {
    case PRODUCTS_REQUEST:
      return true;
    case PRODUCTS_SUCCESS:
    case PRODUCTS_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const productList = (state = [], action) => {
  switch (action.type) {
    case PRODUCTS_SUCCESS:
      return action.products;
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const products = combineReducers({
  isFetching: productsIsFetching,
  list: productList,
});

const variantsIsFetching = (state = false, action) => {
  switch (action.type) {
    case VARIANTS_REQUEST:
      return true;
    case VARIANTS_SUCCESS:
    case VARIANTS_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const variantList = (state = [], action) => {
  switch (action.type) {
    case VARIANTS_SUCCESS:
      return action.variants;
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const variants = combineReducers({
  isFetching: variantsIsFetching,
  list: variantList,
});

const activeAdditionalRow = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_ADDITIONAL_ROW:
      return action.row;
    case ADDITIONAL_ROW_CREATE_SUCCESS:
    case ADDITIONAL_ROW_UPDATE_SUCCESS:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const additionalRowError = (state = null, action) => {
  switch (action.type) {
    case ADDITIONAL_ROW_CREATE_SUCCESS:
    case SET_ACTIVE_ADDITIONAL_ROW:
    case CLEAR:
      return null;
    case ADDITIONAL_ROW_CREATE_FAILURE:
    case ADDITIONAL_ROW_UPDATE_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const additionalRowIsFetching = (state = false, action) => {
  switch (action.type) {
    case ADDITIONAL_ROW_CREATE_REQUEST:
    case ADDITIONAL_ROW_UPDATE_REQUEST:
      return true;
    case ADDITIONAL_ROW_CREATE_SUCCESS:
    case ADDITIONAL_ROW_CREATE_FAILURE:
    case ADDITIONAL_ROW_UPDATE_SUCCESS:
    case ADDITIONAL_ROW_UPDATE_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const additionalRow = combineReducers({
  error: additionalRowError,
  isFetching: additionalRowIsFetching,
  active: activeAdditionalRow,
});

const activeLinkedAdditionalRow = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_LINKED_ADDITIONAL_ROW:
      return action.row;
    case LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const linkedAdditionalRowError = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_LINKED_ADDITIONAL_ROW:
    case CLEAR:
      return null;
    case LINKED_ADDITIONAL_ROW_UPDATE_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const linkedAdditionalRowIsFetching = (state = false, action) => {
  switch (action.type) {
    case LINKED_ADDITIONAL_ROW_UPDATE_REQUEST:
      return true;
    case LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS:
    case LINKED_ADDITIONAL_ROW_UPDATE_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const linkedAdditionalRow = combineReducers({
  error: linkedAdditionalRowError,
  isFetching: linkedAdditionalRowIsFetching,
  active: activeLinkedAdditionalRow,
});

const noteRowIsExtra = (state = false, action) => {
  switch (action.type) {
    case SET_NOTE_ROW:
      return action.isExtra;
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const noteRowActive = (state = null, action) => {
  switch (action.type) {
    case SET_NOTE_ROW:
      return action.row;
    case EXTRA_ROW_UPDATE_SUCCESS:
    case ORDER_ROW_UPDATE_SUCCESS:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const noteRowError = (state = null, action) => {
  switch (action.type) {
    case EXTRA_ROW_UPDATE_FAILURE:
    case ORDER_ROW_UPDATE_FAILURE:
      return action.error;
    case EXTRA_ROW_UPDATE_SUCCESS:
    case ORDER_ROW_UPDATE_SUCCESS:
    case SET_NOTE_ROW:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const noteRowIsFetching = (state = false, action) => {
  switch (action.type) {
    case ORDER_ROW_UPDATE_REQUEST:
    case EXTRA_ROW_UPDATE_REQUEST:
      return true;
    case ORDER_ROW_UPDATE_SUCCESS:
    case ORDER_ROW_UPDATE_FAILURE:
    case EXTRA_ROW_UPDATE_SUCCESS:
    case EXTRA_ROW_UPDATE_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const noteRow = combineReducers({
  isExtra: noteRowIsExtra,
  active: noteRowActive,
  error: noteRowError,
  isFetching: noteRowIsFetching,
});

const defaultReportFilterState = {
  includePlans: false,
  supplierId: null,
};

const defaultReportDialogState = {
  filter: defaultReportFilterState,
  isVisible: false,
  suppliers: [],
};

const reportDialog = (state, action) => {
  switch (action.type) {
    case TOGGLE_REPORT_DIALOG: {
      const isVisible = !!action.show && !!state.active;
      return !!isVisible
        ? {
          isVisible,
          filter: defaultReportFilterState,
          suppliers: _.flow(
            _.filter(x => !!x && !!x.id),
            _.map(x => x.supplier),
            _.filter(x => !!x && !!x.id),
            _.uniqBy('id'),
            _.sortBy([x => x.name])
          )([
            ..._.map(x => x.product, state.rows.rows),
            ..._.map(x => x.product, state.rows.extraRows),
            ...state.customRows,
          ]),
        }
        : defaultReportDialogState;
    }
    case UPDATE_REPORT_FILTER: {
      return {
        ...state.reportDialog,
        filter: !!state.reportDialog.isVisible
          ? {
            ...state.reportDialog.filter,
            includePlans: !!action.includePlans,
            supplierId: action.supplierId,
          }
          : defaultReportFilterState,
      };
    }
    case CLEAR:
      return defaultReportDialogState;
    default:
      return state.reportDialog;
  }
};

const reducers = combineReducers({
  active,
  rows,
  additionalRows,
  customRows,
  error,
  isFetching,
  products,
  variants,
  additionalRow,
  linkedAdditionalRow,
  rooms,
  noteRow,
  reportDialog: (state = defaultReportDialogState) => state,
});

const purchaseOrderView = (state, action) => {
  const newState = reducers(state, action);
  return {
    ...newState,
    reportDialog: reportDialog(newState, action),
  };
};

export default purchaseOrderView;



// WEBPACK FOOTER //
// ./src/reducers/purchaseOrderView.js